import React, { useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const SummaryPieChart = ({ data, period }) => {
    const totalConsumption = useMemo(() => {
        return data.values.reduce((acc, curr) => acc + curr, 0);
    }, [data]);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '75%', // Thinner ring for modern look
        plugins: {
            legend: {
                display: false // Disable default legend
            },
            tooltip: {
                backgroundColor: '#1f2937',
                padding: 12,
                cornerRadius: 8,
                displayColors: true,
                callbacks: {
                    label: function (context) {
                        let label = context.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed !== null) {
                            label += `${context.parsed.toFixed(2)} L`;
                        }
                        return label;
                    }
                }
            }
        },
        elements: {
            arc: {
                borderWidth: 2,
                borderColor: '#ffffff',
                borderRadius: 5, // Rounded ends on segments
            }
        }
    };

    const chartData = {
        labels: data.labels,
        datasets: [
            {
                data: data.values,
                backgroundColor: data.colors,
                hoverOffset: 4
            },
        ],
    };

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 h-full flex flex-col relative overflow-hidden">
            {/* Header */}
            <div className="flex flex-col gap-1 mb-4 z-10">
                <h3 className="text-sm font-bold text-gray-900 tracking-tight">
                    Consumo Total
                </h3>
                {period && (
                    <span className="text-[10px] font-medium text-gray-400 uppercase tracking-wider">
                        {period}
                    </span>
                )}
            </div>

            {/* Custom Legend - Top Right */}
            <div className="absolute top-5 right-5 z-20 bg-gray-50/80 backdrop-blur-sm border border-gray-100 rounded-lg p-3 shadow-sm flex flex-col gap-2 max-w-[120px]">
                {data.labels.map((label, index) => (
                    <div key={label} className="flex items-center gap-2">
                        <span
                            className="w-2.5 h-2.5 rounded-full shrink-0"
                            style={{ backgroundColor: data.colors[index] }}
                        />
                        <span className="text-[10px] font-semibold text-gray-600 truncate">
                            {label}
                        </span>
                    </div>
                ))}
            </div>

            <div className="flex-1 min-h-0 relative flex items-center justify-center">
                {/* Chart */}
                <div className="relative w-full h-full z-10">
                    <Doughnut data={chartData} options={options} />
                </div>

                {/* Center Text Overlay */}
                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none z-0">
                    <span className="text-2xl font-extrabold text-gray-900 tracking-tight">
                        {totalConsumption.toLocaleString('es-MX', { maximumFractionDigits: 2 })}
                    </span>
                    <span className="text-[10px] font-semibold text-gray-400 uppercase mt-0.5">
                        Litros
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SummaryPieChart;
